import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

function AdminRoutes() {
  const [admin, setAdmin] = useState(JSON.parse(localStorage.getItem("adminData")));

  useEffect(() => {
    const adminData = localStorage.getItem("adminData");
    setAdmin(JSON.parse(adminData));
  }, []);

  if (admin != null) {
    return <Outlet />;
  }

  return <Navigate to="/login" />;
}

export default AdminRoutes;
